export enum ProductCataloguesWorkspaceCapabilityAccessOperation {
    create = "0505925c-793b-469e-b084-8699afcc1c10",
    read = "08d60ef7-acb5-465c-a693-00308a400b76",
    update = "4419dbb3-d2fc-465e-b537-8492c42e0ad2",
    delete = "18f762c1-83c8-41c2-aaa3-1cbb7dee7146",
}
